module.exports = __webpack_public_path__ + "static/media/koala2.998dff28.jpg";